import { useMediaQuery } from 'react-responsive';
import config from 'tailwindcss/defaultConfig';

const screens = config.theme?.screens;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const mediaSize = `(min-width: ${screens.lg ?? '1024px'})`;

export const useIsDesktop = () => {
  const isDesktop = useMediaQuery({ query: mediaSize });

  return {
    isDesktop,
    isMobile: !isDesktop,
  };
};
